// let API_URL = 'http://play.underscoretec.com:8085/'
import { config } from '../config';
import * as axios from 'axios';
let API_URL = config.API_URL;
// SHOW TOAST NOTIFICATIONS
function toast(type, message) {
    switch (type) {
        case "success":
            return { type: "TOAST", toastype: type, message }
            break;
        case "info":
            return { type: 'TOAST', toastype: type, message }
            break;
        case "warning":
            return { type: "TOAST", toastype: type, message }
            break;
        case "error":
            return { type: "TOAST", toastype: type, message }
            break;
        default: { }
    }

}

function loaders(data) {
    return {
        type: "FULL_PAGE_LOADER",
        data
    }
}
export function callToast(data) {
    return (dispatch) => {
        dispatch(toast(data.type, data.message));
    }
}

export function uploadImage(data, location) {
    console.log("image ----------------------->", data);
    return (dispatch) => {
        let formData = new FormData();
        formData.append('file', data)
        dispatch(loaders(true))
        axios.post(API_URL + 'file', formData)
            // .then((response) =>{
            //     let data=response.json();
            //     console.log(data);
            //     return data;
            //     })
            .then((response) => {
                let responseJSON = response.data;
                console.log("upload results ===================", responseJSON);
                if (!responseJSON.error) {
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Profile Picture Changed!!'));
                    this.updateUser({ imageId: responseJSON.upload._id });
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', 'Profile Picture Upload Failed !'));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', 'Some error occured !'));
            });
    }
}

export function updateUser(data, location) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'user',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'PUT',
                body: JSON.stringify(data)

            })
            .then((response) =>
                response.json())
            .then((responseJSON) => {
                console.log("------------------------->", responseJSON)
                if (!responseJSON.error) {
                    // localStorage.setItem('id', responseJSON.result._id);
                    // localStorage.setItem('session', responseJSON.result.sessionId)
                    dispatch(loaders(false));
                    dispatch(toast('success', 'User Updated Successfully!'));
                    this.userdetails(responseJSON.result.sessionId)
                    if (location)
                        location.push('/profile');
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', 'User Updation Failed !'));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', 'Some error occured !'));
            });
    }

}



export function register(data, location) {
    return (dispatch) => {
        console.log(API_URL)
        dispatch(loaders(true))
        fetch(API_URL + 'user',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)

            })
            .then((response) =>
                response.json())
            .then((responseJSON) => {
                console.log('i am in registration', responseJSON)
                if (!responseJSON.error) {
                    localStorage.setItem('id', responseJSON.result._id);
                    localStorage.setItem('session', responseJSON.result.sessionId)
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Registered Successfully!'));
                    dispatch(userdetail(responseJSON.result));
                    // this.userdetail(responseJSON.result.sessionId)
                    location.push('/home');
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', 'Registration Failed !'));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', 'Some error occured !'));
            });
    }

}


export function socialLogin(data, location) {
    console.log("social ------- login", data)
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'user/socialLogin',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)

            })
            .then((response) =>
                response.json())
            .then((responseJSON) => {
                console.log("social ------- login", responseJSON);

                if (responseJSON.code == 11000) {
                    dispatch(loaders(false));
                    dispatch(toast('error', 'Login Failed! You are already registered with this email id or phonenumber'));
                }
                else if (!responseJSON.error) {
                    localStorage.setItem('id', responseJSON.result._id);
                    localStorage.setItem('session', responseJSON.result.sessionId)
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Log in Successful!'));
                    dispatch(userdetail(responseJSON.result))
                }

                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', 'Login Failed !'));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', 'Some error occured!'));
            });
    }

}



/** API CALL FOR FETCHING LOGGED USER DETAILS AND DISPATCHING ACTION**/
export function userdetails(session) {
    console.log("in user details");
    return (dispatch) => {
        fetch(API_URL + 'user',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'GET'
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                if (!responseJSON.error)
                    dispatch(userdetail(responseJSON.result))
                else
                    dispatch(userdetail({}))

            })
            .catch((error) => {
                dispatch(userdetail({}))
            });
    }
}

//function for loggedin username 
function userdetail(detail) {
    return {
        type: "LOGGED_USER_DETAILS",
        detail

    }
}


export function groupdetail(data, location) {
    return (dispatch) => {
        console.log(API_URL)
        dispatch(loaders(true))
        fetch(API_URL + 'group',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)

            })

            .then((response) =>
                response.json())
            .then((responseJSON) => {
                if (!responseJSON.error) {
                    console.log('i am in group creation', responseJSON.result)
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Group created Successfully!'));
                    dispatch(groupDetail(responseJSON.result));
                    dispatch(groupByuserId())
                    // this.userdetail(responseJSON.result.sessionId)
                    location.push('/profile/grouplist');
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', 'Group creation Failed !'));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', error));
            });
    }

}
//function for group creation 
function groupDetail(detail) {
    return {
        type: "GROUP_DETAILS",
        detail

    }
}
/** API CALL FOR FETCHING LOGGED group DETAILS AND DISPATCHING ACTION**/
export function groupByuserId() {
    return (dispatch) => {
        console.log(localStorage.getItem('session'))
        fetch(API_URL + 'group/getByUserId',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'GET'
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log('group by userid', responseJSON)
                if (!responseJSON.error) {
                    dispatch(groupList(responseJSON.result))
                }
                else
                    dispatch(groupList([]))

            })
            .catch((error) => {
                dispatch(groupList([]))
            });
    }
}

//function for group username 
function groupList(detail) {
    return {
        type: "GROUPLIST_DETAILS",
        detail

    }
}
//API FOR EDIT USER WITH GETTING USER LIST AND DISPATCHING ACTION
export function editGroup(data, id, location) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'group/updateuser?id=' + id, {
            headers: {
                'x-session-key': localStorage.getItem('session'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(data)
        }).then((response) => response.json())
            .then((responseJSON) => {
                console.log("response------------------>", responseJSON)
                if (responseJSON.error) {
                    dispatch(toast('error', 'Group Updation Failed !'));
                    dispatch(loaders(false))
                }
                else {
                    dispatch(groupByuserId());
                    dispatch(loaders(false))
                    dispatch(toast('success', 'Group Updated Successfully !'));
                    location.push('/profile/grouplist')
                }

            })
            .catch((error) => {
                console.log("group updation error", error)
                dispatch(loaders(false));
                dispatch(toast('error', "Some error occurred"));
            });
    }

}

export function assigneventGroup(data, id) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'group/addevent?id=' + id, {
            headers: {
                'x-session-key': localStorage.getItem('session'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(data)
        }).then((response) => response.json())
            .then((responseJSON) => {
                console.log("response------------------>", responseJSON)
                if (responseJSON.error) {
                    dispatch(toast('error', 'Event assign Failed !'));
                    dispatch(loaders(false))
                }

                else {
                    dispatch(loaders(false))
                    dispatch(userdetails(localStorage.getItem('session')))
                    dispatch(toast('success', 'Event assign Successfully !'));
                }

            })
            .catch((error) => {
                console.log("assign a event to group", error)
                dispatch(loaders(false));
                dispatch(toast('error', "Some error occurred"));
            });
    }
}

//**API CALL FOR LOGIN  AND STORING USERID IN SESSION STORAGE IF REMEMBER ME IS FALSE OTHERWISE STORE IN LOCALSTORAG IF TRUE */
export function login(logindata, location) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'user/login',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(logindata)
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                if (!responseJSON.error) {
                    console.log('login information', responseJSON.result)
                    localStorage.setItem('id', responseJSON.result._id);
                    localStorage.setItem('session', responseJSON.result.sessionId)
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Login Successfully!'));
                    dispatch(userdetail(responseJSON.result));
                    // location.push('/home');
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', 'Login Failed !'));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', 'Password is Incorrect !'));
            });
    }

}


// API CALL FOR FORGOT PASSWORD EMAIL IS SEND TO THE PREFFERED EMAIL OF THE USER 



export function forgotPassword(data, location) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'user/forgotPassword',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                if (responseJSON.error == false) {
                    localStorage.setItem('email', data.email);
                    dispatch(loaders(false));
                    dispatch(toast('success', 'OTP sent to your mail'));
                    location.push('/Otp');
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', 'Invalid Email !'));
            });
    }

}
// API TO VERIFY OTP SENFD THE USER MOBILE
export function verifyOtp(data, location) {
    console.log("data------------------>", data);
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'user/verifyOtp',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log(responseJSON);
                if (!responseJSON.error) {
                    localStorage.setItem('email', data.email);
                    dispatch(loaders(false));
                    dispatch(toast('success', 'OTP Verified succcessfully'));
                    location.push('/Changepwd');
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', 'Invalid Email !'));
            });
    }

}



// API FOR CHANGE PASSWORD
export function changePassword(data, location) {
    console.log("data------------------>", data);
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'user/resetPassword',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log(responseJSON);
                if (!responseJSON.error) {
                    localStorage.removeItem('email');
                    dispatch(loaders(false));
                    dispatch(toast('success', "Password reset Successfully"));
                    location.push('/Login');
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', 'Invalid Email !'));
            });
    }

}
/*************************EVENT CRUD STARTS ***************************** */

// API TO CREATE EVENT

export function addEvent(data, location) {
    if (data.appkey) {
        var url = 'event?token='
    }
    else {
        var url = 'event'
    }
    return (dispatch) => {
        console.log("data------------------------>", data)
        dispatch(loaders(true))

        fetch(API_URL + url,
            {
                headers: {
                    'x-session-key': localStorage.getItem('session'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)

            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log("response----------------------->", responseJSON)
                if (!responseJSON.error && responseJSON.result) {
                    if (responseJSON.result.type == 'Calendar') {
                        localStorage.removeItem('image');
                        localStorage.setItem('event', responseJSON.result._id);
                        dispatch(loaders(false));
                        dispatch(toast('success', 'Event created Successfully!'));
                        dispatch(eventByuserId())
                        // location.push('/profile/createnew');
                    }
                    else {
                        dispatch(loaders(false));
                        dispatch(eventByuserId())
                        dispatch(toast('success', 'Event created Successfully!'));
                        location.push('/profile/eventlist');
                    }

                }
                else {

                    dispatch(loaders(false));
                    dispatch(toast('error', responseJSON.error));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                console.log("response data------------->", error)
                dispatch(toast('error', error.message));
            });
    }

}


// create event by ics file

export function addicsEvent(data, location) {
    return (dispatch) => {
        console.log("data------------------------>", data)
        dispatch(loaders(true))
        fetch(API_URL + 'event/createEventical',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)

            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log("response----------------------->", responseJSON)
                if (!responseJSON.error && responseJSON.result) {
                    if (responseJSON.result.type == 'Calendar') {
                        localStorage.removeItem('image');
                        localStorage.setItem('event', responseJSON.result._id);
                        dispatch(loaders(false));
                        dispatch(toast('success', 'Event created Successfully!'));
                        dispatch(eventByuserId())
                        // location.push('/profile/createnew');
                    }
                    else {
                        dispatch(loaders(false));
                        dispatch(eventByuserId())
                        dispatch(toast('success', 'Event created Successfully!'));
                        location.push('/profile/eventlist');
                    }

                }
                else {

                    dispatch(loaders(false));
                    dispatch(toast('error', responseJSON.error));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                console.log("response data------------->", error)
                dispatch(toast('error', error.message));
            });
    }

}


/** API CALL FOR FETCHING LOGGED USER DETAILS AND DISPATCHING ACTION**/
export function eventByuserId() {
    return (dispatch) => {
        console.log(localStorage.getItem('session'))
        fetch(API_URL + 'event/listCreatedEvent',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'GET'
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log(responseJSON)
                if (!responseJSON.error) {
                    dispatch(eventList(responseJSON.result))
                }
                else
                    dispatch(eventList([]))

            })
            .catch((error) => {
                dispatch(eventList([]))
            });
    }
}


//function for loggedin username 
function eventList(detail) {
    return {
        type: "EVENT_DETAILS",
        detail

    }
}
/** API CALL FOR FETCHING LOGGED USER DETAILS AND DISPATCHING ACTION**/
export function libraryEvent() {
    return (dispatch) => {
        console.log(localStorage.getItem('session'))
        fetch(API_URL + 'event/library',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'GET'
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log(responseJSON)
                if (!responseJSON.error) {
                    console.log('i am in library list')
                    dispatch(libraryList(responseJSON.result))
                }
                else
                    dispatch(libraryList([]))

            })
            .catch((error) => {
                dispatch(libraryList([]))
            });
    }
}


//function for loggedin username 
function libraryList(detail) {
    return {
        type: "LIBRARY_DETAILS",
        detail

    }
}


// mytaps API

export function myTaps() {
    return (dispatch) => {
        console.log(localStorage.getItem('session'))
        fetch(API_URL + 'event/mytaps',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'GET'
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log(responseJSON)
                if (!responseJSON.error) {
                    console.log('i am in taps list')
                    dispatch(mytapList(responseJSON.result))
                }
                else
                    dispatch(mytapList([]))

            })
            .catch((error) => {
                dispatch(mytapList([]))
            });
    }
}


//function for loggedin username 
function mytapList(detail) {
    return {
        type: "MYTAPS_DETAILS",
        detail

    }
}


// Subscription API
export function eventSubscribe(data, location) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'subscription', {
            headers: {
                'x-session-key': localStorage.getItem('session'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(data)
        }).then((response) => response.json())
            .then((responseJSON) => {
                console.log("response------------------>", responseJSON)
                if (responseJSON.error) {
                    dispatch(toast('error', 'Subscription Failed !'));
                    dispatch(loaders(false));

                }

                else {
                    dispatch(loaders(false))
                    dispatch(userdetails(localStorage.getItem('session')));
                    dispatch(toast('success', 'Subscribed Successfully !'));
                }

            })
            .catch((error) => {
                console.log("dfghjkljhgfxzcvbnmkl", error)
                dispatch(loaders(false));
                dispatch(toast('error', "Some error occurred"));
            });
    }
}

export function eventSubscribePull(data, location) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'subscription/unsubscribe', {
            headers: {
                'x-session-key': localStorage.getItem('session'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(data)
        }).then((response) => response.json())
            .then((responseJSON) => {
                console.log("response------------------>", responseJSON)
                if (responseJSON.error) {
                    dispatch(toast('error', 'Subscription Failed !'));
                    dispatch(loaders(false))
                }

                else {
                    dispatch(loaders(false))
                    dispatch(userdetails(localStorage.getItem('session')))

                    dispatch(toast('success', 'Unsubscribed Successfully !'));
                }

            })
            .catch((error) => {
                console.log("dfghjkljhgfxzcvbnmkl", error)
                dispatch(loaders(false));
                dispatch(toast('error', "Some error occurred"));
            });
    }
}


// API TO DELETE THE EVENT
export function deleteEvent(id, location) {
    return (dispatch) => {

        fetch(API_URL + 'event/delete?id=' + id,
            {
                headers: {
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'PUT'
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log(responseJSON)
                if (!responseJSON.error) {
                    localStorage.removeItem('event', id);
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Event Deleted Successfully!'));
                    dispatch(eventByuserId());
                    location.push('/profile/eventlist');
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', "Some error occurred"));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', "Some error occurred"));
            });
    }
}

//API FOR EDIT USER WITH GETTING USER LIST AND DISPATCHING ACTION
export function editEvent(data, id, location, publish, unpublish) {
    console.log('peblish ', publish)
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'event?id=' + id, {
            headers: {
                'x-session-key': localStorage.getItem('session'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(data)
        }).then((response) => response.json())
            .then((responseJSON) => {
                console.log("response------------------>", responseJSON)
                if (responseJSON.error) {
                    dispatch(toast('error', 'Event Updation Failed !'));
                    dispatch(loaders(false))
                }
                else if (unpublish) {
                    console.log('Unpublish me')
                    localStorage.setItem('event', responseJSON.result._id);
                    dispatch(eventByuserId());
                    dispatch(loaders(false))
                    dispatch(toast('success', 'Event Unpublished Successfully !'));
                    location.push('/profile/eventdetail' + id)
                }
                else if (publish) {
                    localStorage.setItem('event', responseJSON.result._id);
                    dispatch(eventByuserId());
                    dispatch(loaders(false))
                    dispatch(toast('success', 'Event Published Successfully !'));
                    location.push('/profile/eventdetail' + id)
                }

                else if (responseJSON.result.type == 'Calendar') {
                    localStorage.setItem('event', responseJSON.result._id);
                    dispatch(eventByuserId());
                    dispatch(loaders(false))
                    dispatch(toast('success', 'Event Updated Successfully !'));
                }
                else {
                    dispatch(eventByuserId());
                    dispatch(loaders(false))
                    dispatch(toast('success', 'Event Updated Successfully !'));
                    location.push('/profile/eventlist')
                }

            })
            .catch((error) => {
                console.log("dfghjkljhgfxzcvbnmkl", error)
                dispatch(loaders(false));
                dispatch(toast('error', "Some error occurred"));
            });
    }

}

/*********************************Calendar crud starts *************************** */

export function createCalendar(data, location) {
    return (dispatch) => {
        console.log("Enter into create calendar")
        dispatch(loaders(true))
        fetch(API_URL + 'calendar',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)

            })
            .then((response) =>
                response.json())
            .then((responseJSON) => {
                console.log("response----------------------->", responseJSON)
                if (!responseJSON.error) {
                    localStorage.removeItem('event');
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Calendar created Successfully!'));
                    location.push('/profile/eventlist');
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', responseJSON.error));
                }

            })
            .catch((error) => {
                dispatch(loaders(false));
                console.log('error in calendar create')
                dispatch(toast('error', error.message));
            });
    }

}

// updateCalByEvent
// API TO UPDATE THE EVENT ON  EXISTING CALENDAR
export function updateCalByEvent(id, eventId, location) {
    return (dispatch) => {
        console.log(API_URL)
        dispatch(loaders(true))
        fetch(API_URL + 'calendar/Addevent?id=' + id,
            {
                headers: {
                    'x-session-key': localStorage.getItem('session'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'PUT',
                body: JSON.stringify(eventId)

            })
            .then((response) =>
                response.json())

            .then((responseJSON) => {
                console.log("response----------------------->", responseJSON)
                if (!responseJSON.error) {
                    localStorage.removeItem('event');
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Calendar added Successfully!'));
                    location.push('/profile/eventlist');
                }

            })
            .catch((error) => {
                console.log('xxxxxxxxxxxxxxxxxxxx', error)
                dispatch(loaders(false));
                dispatch(toast('error', 'Some error occured'));
            });
    }

}

/** API CALL FOR FETCHING LOGGED USER DETAILS AND DISPATCHING ACTION**/

export function editCalendar(data, id, location) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'calendar/Update?id=' + id, {
            headers: {
                'x-session-key': localStorage.getItem('session'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(data)
        }).then((response) => response.json())
            .then((responseJSON) => {
                console.log("response------------------>", responseJSON)
                if (responseJSON.error) {
                    dispatch(toast('error', 'calendar Updation Failed !'));
                    dispatch(loaders(false))
                }

                else if (!responseJSON.error) {
                    localStorage.setItem('calendar', responseJSON.result._id);
                    dispatch(allCalendar());
                    dispatch(loaders(false))
                    dispatch(toast('success', 'calendar Updated Successfully !'));
                    location.push('/mytaps')
                }
                else {
                    dispatch(loaders(false))
                    dispatch(toast('error', 'Some error occurred !'));

                }

            })
            .catch((error) => {
                console.log("aqwserfd", error)
                dispatch(loaders(false));
                dispatch(toast('error', "Some error occurred"));
            });
    }

}


// API TO DELETE THE EVENT
export function deleteCalendar(id, location) {
    return (dispatch) => {

        fetch(API_URL + 'calendar?id=' + id,
            {
                headers: {
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'PUT'
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log(responseJSON)
                if (!responseJSON.error) {
                    localStorage.removeItem('calendar', id);
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Calendar Deleted Successfully!'));
                    dispatch(myTaps());
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', "Some error occurred"));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                dispatch(toast('error', "Some error occurred"));
            });
    }
}

/** API CALL FOR FETCHING LOGGED CALENDAR DETAILS AND DISPATCHING ACTION**/
export function allCalendar() {
    return (dispatch) => {
        console.log(localStorage.getItem('session'))
        fetch(API_URL + 'calendar/getAllCalendar',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'GET'
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log(responseJSON)
                if (!responseJSON.error)
                    dispatch(calendarList(responseJSON.result))
                else
                    dispatch(calendarList([]))

            })
            .catch((error) => {
                dispatch(calendarList([]))
            });
    }
}

//function for loggedin username 
function calendarList(detail) {
    return {
        type: "CALENDAR_DETAILS",
        detail

    }
}

// sharing


export function calendarPublish(data, id, location, publish, unpublish) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'calendar/publish?id=' + id, {
            headers: {
                'x-session-key': localStorage.getItem('session'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(data)
        }).then((response) => response.json())
            .then((responseJSON) => {
                console.log("response------------------>", responseJSON)
                if (responseJSON.error) {
                    dispatch(toast('error', 'calendar Updation Failed !'));
                    dispatch(loaders(false))
                }
                else if (unpublish) {
                    console.log('Unpublish me')
                    localStorage.setItem('calendar', responseJSON.result._id);
                    dispatch(eventByuserId());
                    dispatch(loaders(false))
                    dispatch(toast('success', 'calendar Unpublished Successfully !'));
                    location.push('/profile/eventdetail')
                }
                else if (publish) {
                    localStorage.setItem('calendar', responseJSON.result._id);
                    dispatch(eventByuserId());
                    dispatch(loaders(false))
                    dispatch(toast('success', 'calendar Published Successfully !'));
                    location.push('/profile/eventdetail')
                }

                else {
                    dispatch(loaders(false))
                    dispatch(toast('error', 'Some error occurred !'));

                }

            })
            .catch((error) => {
                console.log("------------------->", error)
                dispatch(loaders(false));
                dispatch(toast('error', "Some error occurred"));
            });
    }

}

export function shareCalendar(data) {
    return (dispatch) => {
        console.log("data------------------------>", data)
        dispatch(loaders(true))
        fetch(API_URL + 'sharing',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)

            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log("response----------------------->", responseJSON)
                if (responseJSON) {
                    dispatch(loaders(false));
                    dispatch(toast('success', 'Shared Successfully!'));
                    dispatch(myTaps())
                    // location.push('/profile/createnew');
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('erroe', 'Some error Occured!'));
                }
            })
            .catch((error) => {
                dispatch(loaders(false));
                console.log("response data------------->", error)
                dispatch(toast('error', error.message));
            });
    }

}

// api key generation start
export function createApikey(data, location) {
    return (dispatch) => {
        dispatch(loaders(true))
        fetch(API_URL + 'Token',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(data)

            })
            .then((response) =>
                response.json())
            .then((responseJSON) => {
                console.log("response----------------------->", responseJSON)
                if (!responseJSON.error) {
                    dispatch(loaders(false));
                    dispatch(apikeycreatedby())
                    dispatch(toast('success', 'Key created Successfully!'));
                    location.push('/profile/businessapi');
                }
                else {
                    dispatch(loaders(false));
                    dispatch(toast('error', responseJSON.error));
                }

            })
            .catch((error) => {
                dispatch(loaders(false));
                console.log('error in Key creation')
                dispatch(toast('error', error.message));
            });
    }

}

// export function apikeybyid(id) {
//     return (dispatch) => {
//         console.log(localStorage.getItem('session'))
//         fetch(API_URL + 'Token?id='+id,
//             {
//                 headers: {
//                     'x-session-key': localStorage.getItem('session')
//                 },
//                 method: 'GET'
//             })
//             .then((response) => response.json())
//             .then((responseJSON) => {
//                 console.log(responseJSON)
//                 if (!responseJSON.error) {
//                     dispatch(apikeyList(responseJSON.result))
//                 }
//                 else
//                     dispatch(apikeyList([]))

//             })
//             .catch((error) => {
//                 dispatch(apikeyList([]))
//             });
//         }
//     }

//function for loggedin username 


export function apikeycreatedby() {
    return (dispatch) => {
        console.log(localStorage.getItem('session'))
        fetch(API_URL + 'Token/createdBy',
            {
                headers: {
                    'x-session-key': localStorage.getItem('session')
                },
                method: 'GET'
            })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log(responseJSON)
                if (!responseJSON.error) {
                    dispatch(apikeyList(responseJSON.result))
                }
                else
                    dispatch(apikeyList([]))

            })
            .catch((error) => {
                dispatch(apikeyList([]))
            });
    }
}
function apikeyList(detail) {
    return {
        type: "APPKEY_DETAILS",
        detail

    }
}


// WEBPACK FOOTER //
// ./src/redux/action.js